import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateFacturas } from "@/typings/store/plugins/easyFirestore/facturas";

const getters: GetterTree<StateFacturas, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const facturas = {
  firestorePath: "dev/v1/facturas",
  firestoreRefType: "collection",
  moduleName: "facturas",
  statePropName: "all",
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: "%convertTimestamp%", // default
      updated_at: "%convertTimestamp%", // default
    },
  },

  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default facturas;
